import { createContext, useContext, useLayoutEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { reportMailClick } from '@/api/query/mailClick';
import { resolveMailClickPayloadFromSearch } from '@/common/functions/reportMailClick';
import { setupUtms } from '@/common/functions/setupUtms';
import useMarketingTracking from './tracking/useMarketingTracking';

const TrackingContext = createContext(null);

export const useTracking = () => {
	const context = useContext(TrackingContext);

	if (!context) {
		throw new Error('useTracking must be used within TrackingProvider');
	}

	return context;
};

export const TrackingProvider = ({ children }) => {
	const location = useLocation();
	const marketingTracking = useMarketingTracking();

	const { mutate: reportMailClickMutate } = useMutation({
		mutationFn: reportMailClick,
	});

	useLayoutEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		setupUtms(searchParams);

		const mailClickPayload =
			resolveMailClickPayloadFromSearch(searchParams);

		if (!mailClickPayload) {
			return;
		}

		reportMailClickMutate(mailClickPayload);
	}, [location.search, reportMailClickMutate]);

	return (
		<TrackingContext.Provider value={marketingTracking}>
			{children}
		</TrackingContext.Provider>
	);
};

export default TrackingProvider;
